import NiceModal from '@ebay/nice-modal-react';
import React, { Suspense } from 'react';

import { MODALS } from '@/shared/config/modals';

const JettonRoundDetailModalLazy = React.lazy(() => import('./JettonRoundDetailModal').then((m) => ({ default: m.JettonRoundDetailModal })));
type JettonRoundDetailModalProps = React.ComponentProps<
  typeof import('./JettonRoundDetailModal').JettonRoundDetailModal
>;

NiceModal.register(
  MODALS.JETTON_ROUND_DETAIL,
  NiceModal.create((props: JettonRoundDetailModalProps) => (
    <Suspense fallback={null}>
      <JettonRoundDetailModalLazy {...props} />
    </Suspense>
  )),
);
